import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import {
  catchError,
  debounceTime,
  distinctUntilChanged,
  filter,
  map,
  switchMap,
  takeUntil,
  tap,
} from 'rxjs/operators';
import { ModalService } from '@purespectrum1/ui/modal';
import { EditSuppliersModalComponent } from '../../edit-suppliers/edit-supplier-modal/edit-suppliers-modal.component';
import { CPI, CpiMetadata } from '../../../../shared/interfaces/cpi.interface';
import { SurveyMetaDataService } from '../../../../shared/services/survey-meta-data/survey-meta-data.service';
import { BuyerApiService } from '../../../../shared/services/buyer-api/survey.service';
import { CpiService } from '../../../services/cpi/cpi.service';
import { GetBuyerData } from '../../../../shared/interfaces/survey-meta-data.interface';
import { CreateSurveyService } from '../../../create-survey.service';
import { Constants } from '../header.constants';
import { MultiCountryDraftService } from '../../../services/multi-country-draft/multi-country-draft.service';
import { MultiCountryService } from '../../../shared/ui/multicountry/services/multi-country.service';
import { of, Subject, Subscription } from 'rxjs';
import { EventEmitterService } from '../../../../shared/services/event-emitter/event-emitter.service';
import { Supplier } from '../../../shared/interfaces/pricing.interface';
import {
  BlendSupplier,
  BlendSupplierGroup,
  BuyerSurveyResponse,
  EachSupplier,
  EmptyBlendSupplierGroup,
  GetSupplierBlendInterface,
  SupplierResponseInterface,
  UpdateSurveyFieldsApiResponse,
} from '../../../../shared/interfaces/survey.interface';
import { FlexibilityPricesParams } from '../../../../shared/interfaces/supplier-api.interface';
import { FeasibilityResponse } from '../../../../shared/interfaces/feasibility.interface';
import { AuthService } from '../../../../shared/services/auth/auth.service';
import { Confirmation } from './cpi-override-confirmation/types/confirmation';
import { LayoutConstants } from '../../layout-constants';
import { DecimalPipe } from '@angular/common';
import { LoaderService } from '@purespectrum1/ui/loader';
import { TemplateService } from '../../../../shared/services/template/template.service';
import { ToasterService } from '@purespectrum1/ui/toaster-service';
import { notifyMessage } from '../../../../shared/constants/notify-message';
import { TruncateNumber } from '../../../../create-surveys/utils/truncate-number';
import { FeasibilityDataService } from '../../../services/feasibility/feasibility-data.service';
import { Constants as CreateSurveyConstants } from '../../../../shared/constants/create-survey.constants';
import { ManageSuppliersService } from '../../../../shared/services/manage-suppliers-service/manage-suppliers.service';
import { SupplierBlendAlerts } from '../../../domain/supplier-blend-alerts';
import { McSpvSurveyRequest } from '../../../shared/ui/multicountry/interface/multi-country.interface';
import { CURRENCY_CODE } from '../../../../shared/constants/currency-units';
import { CommonService } from '../../../../shared/services/common-service/common-service';
import {
  CurrencyExchangeRate,
  CurrencyExchangeRateResponse,
} from '../../../../shared/interfaces/create-surveys.interface';
import { TableExpandableRowDirective } from '@purespectrum1/ui/table';
import { Router } from '@angular/router';
import { SimilarSurvey } from '../../../shared/interfaces/similar-surveys.interface';
import { SimilarProjectsService } from '../../../services/similar-projects/similar-projects.service';
import { SectionToggleInfo } from '@purespectrum1/ui/accordion';
import {
  SimilarProjectsRequest,
  SimilarProjectsResponse,
} from './../../../../shared/interfaces/similar-projects.interface';
import { isEqual } from '../../../utils/deep-compare';
import { delay } from '../../../../shared/utils/delay';
import { PurePriceOverride } from '../../../services/domain/pure-price-override';

@Component({
  selector: 'ps-ui-cpi',
  templateUrl: './cpi.component.html',
  styleUrls: ['./cpi.component.css', '../header-dropdown.scss'],
})
export class CpiComponent implements OnInit, OnDestroy {
  private _subscriptions: Subscription = new Subscription();
  loading: boolean = false;
  totalCPI?: number = 0;
  cpi: CPI[] = [];
  surveyId!: number;
  public hasMcPreDraftData: boolean = false;
  averageCPI: number = 0;
  currencySymbol: string = '';
  operatorOverrideCpi: string = '';
  globalOverrideCpi: number = 0;
  globalPriceOveride: boolean = false;
  selectivePriceOveride: boolean = false;
  isSuppliersListChecked: boolean = true;
  cpiOverrideConfirmation: Confirmation = Confirmation.confirmed();
  cpiRequireConfirmation = false;
  maxCpiThreshold: number = LayoutConstants.MAX_CPI_THRESHOLD;
  updateCPI: boolean = false;
  private _defaultFlexibility: number = LayoutConstants.DEFAULT_FLEXIBILITY;
  loggedInAsServiceBuyer: boolean = false;
  manualSCPIOverrideEnabled: boolean = false;
  isPricingMultiplierAdded: boolean = false;
  isPurePriceApplied: boolean = false;
  showManualSuppOverride: boolean = true;
  loadingBlends: boolean = true;
  selectedBlend: EachSupplier | any;
  selectedTemplateBlend: string = '';
  manualAllocationEdit: boolean = false;
  getBlendLabel: string = '';
  mcQbGlobalPriceOveride: boolean = false;
  public supplierGroup!: { groupName?: string; cpi?: number | string };
  public totalRemaining!: number;
  public totalAllocations: number = 0;
  public totalFeasibility: number = 0;
  public completesNeeded: number = 0;
  public suppliersCount!: number;
  public minimumGroupSize: number = 1;
  public individual_supplier: number = 1;
  public isMCQBSurvey: boolean = false;
  public enableGlobalPriceOverRide = true;
  public similarSurveys: SimilarProjectsResponse[] = [];
  public isSimilarProject: boolean = false;
  public isGlobalSearch: boolean = false;
  public isDoneGlobalSearch: boolean = false;
  public isSearchCancelled = false;
  public isEnableTargetMargin: boolean = false;
  public isAidaEnabled: boolean = false;
  @ViewChild(TableExpandableRowDirective)
  public expandable!: TableExpandableRowDirective;
  supplierFlex = { value: 100, isFlexible: true };
  blendSupplierGroups: BlendSupplierGroup = {
    listOfOptions: [],
  };
  tempSuppliers: SupplierResponseInterface[] = [];
  blendSupplierGroupEmpty: Array<EmptyBlendSupplierGroup> = [];
  private _manualAllocationEdit: boolean = false;
  readonly Constants = Constants;
  private _metadata: CpiMetadata = {
    loi: 0,
    ir: 0,
    lang: '',
    completesRequired: 0,
    fieldTime: 0,
  };
  public defaultPurePriceOverride: PurePriceOverride = new PurePriceOverride(
    false,
    0
  );

  private _cancelCommand$ = new Subject<void>();
  private _eligibleSuppliers?: Supplier[];
  private _suppliers?: SupplierResponseInterface[];
  private _flexibilityPrice = <FlexibilityPricesParams>{};
  private _feasibilityData?: FeasibilityResponse;
  private _buyerData?: GetBuyerData;
  private _supplierBlendData: GetSupplierBlendInterface[] = [];
  private _surveyDetails?: BuyerSurveyResponse;
  private _isServiceBuyerOperation: boolean = false;
  private _isPurePriceRateCardEnabled: boolean = false;
  private _appliedBlendId?: string;
  private _mcSuvSurveyPayload: McSpvSurveyRequest;
  private companyFx: number;
  private _currencyExchangeRate: CurrencyExchangeRate =
    {} as CurrencyExchangeRate;

  get user() {
    return this._auth.user;
  }

  constructor(
    private _surveyMetaDataService: SurveyMetaDataService,
    private _cpiService: CpiService,
    private _modal: ModalService,
    private _createSurveyService: CreateSurveyService,
    private _buyerApiService: BuyerApiService,
    private _multiCountryDraftService: MultiCountryDraftService,
    private _eventEmitterService: EventEmitterService,
    private _decimalPipe: DecimalPipe,
    private _loading: LoaderService,
    private readonly _auth: AuthService,
    private readonly _templateService: TemplateService,
    private _toastr: ToasterService,
    private _feasibilityDataService: FeasibilityDataService,
    private _manageSuppliersService: ManageSuppliersService,
    private _multiCountryService: MultiCountryService,
    private _similarProjectsService: SimilarProjectsService,
    private _commonService: CommonService,
    private _route: Router
  ) {
    this.loggedInAsServiceBuyer = this._auth.isLoggedInAsServiceBuyer();
  }

  ngOnInit() {
    this._isServiceBuyerOperation = this._auth.isLoggedInAsServiceBuyer();
    this.isSimilarProject = !!this._auth.buyerConfig?.enableSimilarSurveys;
    this.isEnableTargetMargin = !!this._auth.buyerConfig?.enableTargetMargin;
    this.companyFx = this._auth.companyConfig?.fx || CURRENCY_CODE.US;
    if (this.loggedInAsServiceBuyer && this.companyFx !== CURRENCY_CODE.US) {
      this._commonService.getCurrencyExchangeRate(this.companyFx).subscribe(
        (response: CurrencyExchangeRateResponse) => {
          this._currencyExchangeRate = response.currencies;
        },
        (error) => {
          this._toastr.error(error.error.msg);
        }
      );
    }

    this._surveyMetaDataService
      .isManuallyEditedAllocationSaved()
      .subscribe((state) => {
        this._manualAllocationEdit = state;
      });

    this._subscriptions.add(
      this._surveyMetaDataService
        .getSupplierSpecificInfo()
        .subscribe((data) => {
          if (data.supplierBlendData.length !== 0) {
            this._supplierBlendData = data.supplierBlendData;
          }
          this._eligibleSuppliers = data.eligibleSuppliers;
        })
    );

    this._subscriptions.add(
      this._surveyMetaDataService
        .getBuyerSurveyData()
        .subscribe((surveyData) => {
          this._surveyDetails = surveyData;
          this.isMCQBSurvey = !!this._surveyDetails?.mc?.SVP;
          if (!this.completesNeeded) {
            this.completesNeeded =
              surveyData.click_balancing == 0
                ? surveyData.completes_required
                : surveyData.estimated_clicks;
          }
          this.currencySymbol = surveyData.currency_symbol;
          this._isPurePriceRateCardEnabled =
            surveyData.is_pure_price_rate_card_enable;
          this.isAidaEnabled = !!surveyData.aida?.enabled;
        })
    );

    this._subscriptions.add(
      this._surveyMetaDataService
        .getPurePriceRateCardEnable()
        .subscribe((purePriceRateCardEnable) => {
          this._isPurePriceRateCardEnabled = purePriceRateCardEnable;
          this.showManualSuppOverride = !this._isPurePriceRateCardEnabled;
        })
    );

    this._subscriptions.add(
      this._multiCountryDraftService
        .getMultiCountryPreDraftData()
        .subscribe((data) => {
          this.loading = true;
          this.hasMcPreDraftData = !!data.length;
          this.averageCPI = this._cpiService.getAverageCpi(data);
          this.loading = false;
        })
    );

    this._subscriptions.add(
      this._surveyMetaDataService
        .getCPIData()
        .subscribe(
          ({
            suppliers,
            feasibility,
            buyerData,
            totalFeasibility,
            flexibilityPrice,
            loading,
          }) => {
            this.loading = loading;
            this._flexibilityPrice =
              flexibilityPrice || ({} as FlexibilityPricesParams);
            if (
              !suppliers ||
              !feasibility ||
              !buyerData ||
              typeof totalFeasibility !== 'number'
            ) {
              return;
            }
            this._feasibilityData = feasibility;
            this._buyerData = buyerData;
            this.isPricingMultiplierAdded =
              !!this._feasibilityData.pricing_multplier;
            this._mapOverrideCpi(flexibilityPrice);
            this.surveyId = buyerData.surveyId;
            this._metadata = {
              loi: buyerData.expected_loi,
              ir: buyerData.expected_ir,
              lang: buyerData.language,
              completesRequired: this._calculateCompletesNeeded(),
              fieldTime: buyerData.field_time,
            };
            this.completesNeeded = this._calculateCompletesNeeded();
            this._suppliers = suppliers;
            this.tempSuppliers = suppliers || [];
            this._templateService.sendSupplierInfo(this._suppliers);
            const isActiveSurvey =
              Number(buyerData.surveyId) === Number(this.surveyId);
            this.cpi = this._cpiService.mapCpi(
              suppliers,
              buyerData,
              feasibility,
              isActiveSurvey
            );
            this._surveyMetaDataService.sendCPIDropdownData(this.cpi);
            if (this._flexibilityPrice.survey_price_override) {
              this.totalCPI = this._flexibilityPrice.survey_price_override;
            } else {
              this.totalCPI = this._cpiService.getTotalCpi(
                this.cpi,
                feasibility
              );
            }
            if (this.isMCQBSurvey && this.selectivePriceOveride) {
              this._setSelectedMcSpvSurveyFeasibilityCpi();
            }
            this._eventEmitterService.sendFeasibilityCPi({
              maxFeasibility: feasibility.max_feasibility,
              recommendedCpi: feasibility.recommended_cpi,
              totalCpi: this.totalCPI,
              surveyPriceOverride: Number(
                this._flexibilityPrice.survey_price_override
              ),
              surveyId: Number(this.surveyId),
              expectedIr: buyerData.expected_ir,
            });
            this._surveyMetaDataService.setShowPurepriceFlyout(
              this.globalPriceOveride,
              this.selectivePriceOveride || this.manualSCPIOverrideEnabled
            );
            this._setSupplierBlendsData();
          }
        )
    );

    this._surveyMetaDataService.getBlendsData().subscribe((state) => {
      this.selectedTemplateBlend = state;
    });

    this._subscriptions.add(
      this._surveyMetaDataService
        .getSupplierOverrideValue()
        .subscribe((payload: boolean) => {
          this.manualSCPIOverrideEnabled = payload;
        })
    );

    this._subscriptions.add(
      this._createSurveyService
        .getIsPurePrieApplied()
        .subscribe((payload: boolean) => {
          this.isPurePriceApplied = payload;
        })
    );

    this._subscriptions.add(
      this._surveyMetaDataService
        .getSuppliersSelected()
        .subscribe((selectedSupplier) => {
          if (!selectedSupplier.blend_id) {
            this.removeBlends();
          }
        })
    );
    this._subscriptions.add(
      this._surveyMetaDataService
        .getMcQbOverrideValue()
        .subscribe((mcQbOverRide) => {
          this.mcQbGlobalPriceOveride = mcQbOverRide && this.globalPriceOveride;
        })
    );

    this._subscriptions.add(
      this._multiCountryDraftService
        .getMcSpvSurveyRequest()
        .subscribe((mcSvpSurveyRequest) => {
          this._mcSuvSurveyPayload = mcSvpSurveyRequest;
        })
    );

    this._subscriptions.add(
      this._surveyMetaDataService
        .getPurePriceOverride()
        .subscribe((purePriceOverride) => {
          this.defaultPurePriceOverride = purePriceOverride;
        })
    );

    this._showManualSuppOverride();
    this.enableGlobalPriceOverRide = [
      this.loggedInAsServiceBuyer,
      !this._auth.buyerConfig?.enableMarginMax,
      !this._auth.buyerConfig?.enableTargetMargin,
    ].every((data) => !!data);
    this._getSimilarProjects();
  }

  private _calculateCompletesNeeded() {
    return this._buyerData?.clickBalancing
      ? this._buyerData?.estimatedClicks!
      : this._buyerData?.completesRequired!;
  }

  private _showManualSuppOverride() {
    this.showManualSuppOverride = !this._isPurePriceRateCardEnabled;
  }

  private _setSupplierBlendsData() {
    if (!this._supplierBlendData || !this._supplierBlendData.length) {
      const locale = this._surveyDetails?.survey_localization || null;
      this._subscriptions.add(
        this._buyerApiService
          .getSupplierBlends(locale)
          .subscribe((supplierBlendData: GetSupplierBlendInterface[]) => {
            this._supplierBlendData = supplierBlendData;
            this._processSupplierBlendData();
            this.loadingBlends = false;
          })
      );
    } else {
      this._processSupplierBlendData();
    }
  }

  private _processSupplierBlendData() {
    if (this._supplierBlendData?.length) {
      let mappedBlends = {
        // Filtering blends that have at least 2 of the available suppliers
        listOfOptions: this._supplierBlendData
          .filter((blendToFilter) => {
            let includeBlend = false;
            blendToFilter.suppliers.forEach((suppFromBlend) => {
              let surveySuplrsInBlend: number = 0;
              this._suppliers?.forEach((scopeSupplier) => {
                scopeSupplier.suppliers.forEach((subSupplier) => {
                  if (
                    this._manageSuppliersService
                      .getBlendSupplierIds(suppFromBlend)
                      .includes(subSupplier.id)
                  ) {
                    surveySuplrsInBlend++;
                  }
                });
              });
              // Validate if at least 1 individual or group in the blend are able to be applied in the survey
              if (this.validateGroupBlend(suppFromBlend, surveySuplrsInBlend)) {
                includeBlend = true;
              }
            });
            return includeBlend;
            // After filtering, is added an attribute to know which blend is selected in the dropdown
          })
          .map((blend) => {
            return { ...blend, isSelected: false };
          }),
      };
      this.blendSupplierGroups = mappedBlends;
      this.selectedBlend = {};
      if (
        this._surveyDetails &&
        this._surveyDetails.blend_id &&
        !this.selectedTemplateBlend
      ) {
        // set selected blend
        this.selectedBlend = mappedBlends.listOfOptions.find(
          (blends) => blends.id === this._surveyDetails?.blend_id
        );
      }
      if (this.selectedTemplateBlend) {
        this.selectedBlend = mappedBlends.listOfOptions.find(
          (blends) => blends.id === this.selectedTemplateBlend
        );
      }

      this._showMissingSupplierWarning();

      this.blendSupplierGroups.listOfOptions.unshift({
        id: '0',
        config_name: '-- Remove Supplier Blend --',
        isSelected: false,
        typeOfDropDownOption: 4,
        setItemTextColorToBlue: true,
      });
    } else if (!this._supplierBlendData?.length) {
      this.blendSupplierGroups.listOfOptions.unshift({
        config_name: 'No Supplier Blends Saved',
        typeOfDropDownOption: 2,
        isSelected: false,
      } as any);
    }
  }

  private _showMissingSupplierWarning() {
    const blendsAlerts = new SupplierBlendAlerts(
      this._appliedBlendId,
      this._surveyDetails,
      this._supplierBlendData,
      this.selectedBlend,
      this._suppliers
    );
    if (blendsAlerts.isDefaultBlendNotApplied()) {
      this._toastr.error(
        notifyMessage.warningMessage.DEFAULT_BLEND_NOT_APPLIED
      );
    }
    if (blendsAlerts.thereIsMissMatchSuppliers()) {
      this._toastr.warning(notifyMessage.warningMessage.MISS_MATCH_SUPPLIERS);
      this._appliedBlendId = this._surveyDetails?.blend_id;
    }
  }

  validateGroupBlend(
    suppFromBlend: BlendSupplier,
    surveySuplrsInBlend: number
  ) {
    return (
      suppFromBlend.supplier_id &&
      ((suppFromBlend.supplier_id.length >= this.minimumGroupSize &&
        surveySuplrsInBlend >= this.minimumGroupSize) ||
        (suppFromBlend.supplier_id.length === this.individual_supplier &&
          surveySuplrsInBlend))
    );
  }

  /**
   * * TODO this code it's duplicated, we need to adress it in PD-11190 Likely the same function from
   * projects/purespectrum-ui/marketplace/src/create-surveys/layout/edit-suppliers/edit-suppliers.component.ts selectBlend()
   */
  selectBlend(event: EachSupplier) {
    const resetBlends = 4;
    this.selectedBlend = event;
    this.unGroupAllSuppliers();
    if (event.typeOfDropDownOption === resetBlends) {
      this._resetFlexibility();
      this.redistributeSuppliers();
      return;
    }
    this._sendSelectedBlendForUpdateInMcSvpCache(event);
    this._applyBlend(event);
  }

  private _sendSelectedBlendForUpdateInMcSvpCache(blend: EachSupplier | null) {
    if (!this.isMCQBSurvey) {
      return;
    }

    if (!blend) {
      this._sendMcSpvEachUpdateForCache({ blend_id: '' });
      return;
    }

    this._sendMcSpvEachUpdateForCache({ blend_id: String(blend.id) });
  }

  private _applyBlend(blend: EachSupplier) {
    this._buyerApiService
      .updateSurveyField(this.surveyId, [
        {
          op: 'replace',
          path: '/blend_id',
          value: blend.id,
        },
      ])
      .subscribe(
        (data: UpdateSurveyFieldsApiResponse) => {
          this._setAsSelected(blend);
          this._suppliers = data.supplier;
          this._setSupplierValidFlag();
          this._setSuppliers();
        },
        (err) => {
          this.selectedBlend = {};
          this.redistributeSuppliers();
          const errMsg = err.error.ps_api_response_message;
          this._toastr.error(errMsg);
        }
      );
  }

  private _setSupplierValidFlag() {
    if (this._suppliers && this._feasibilityData && this._buyerData) {
      this.cpi = this._cpiService.mapCpi(
        this._suppliers,
        this._buyerData,
        this._feasibilityData,
        true
      );
    }
    this._suppliers?.forEach((supplier) => {
      if (supplier.cpi == 0 && !supplier.group_ref) {
        supplier.isValid = false;
      } else {
        supplier['isValid'] = supplier.is_active === false ? false : true;
      }
    });
  }

  private _resetFlexibility() {
    this.supplierFlex.value = this._defaultFlexibility;
    this.updateFlexValue(this._defaultFlexibility);
  }

  private _setAsSelected(event: EachSupplier) {
    const blendIndex = this.blendSupplierGroups.listOfOptions.findIndex(
      (blendToSelect) => blendToSelect.id === event.id.toString()
    );
    if (blendIndex !== undefined && blendIndex >= 0) {
      this.removeSelectedBlend();
      this.selectedBlend = this.blendSupplierGroups.listOfOptions[
        blendIndex
      ].isSelected = true;
      this.selectedBlend = this.blendSupplierGroups.listOfOptions[blendIndex];
      this.getBlendLabel =
        this.blendSupplierGroups.listOfOptions[blendIndex].config_name;
    }
  }

  /**
   * 	Remove selected from the blend object to not show de check icon in the dropdown
   */
  removeSelectedBlend() {
    const blendIndex = this.blendSupplierGroups.listOfOptions.findIndex(
      (blendToUnselect) => blendToUnselect.isSelected
    );
    if (blendIndex !== undefined && blendIndex >= 0) {
      this.blendSupplierGroups.listOfOptions[blendIndex].isSelected = false;
    }
    this._appliedBlendId = undefined;
  }

  updateFlexValue(flexValue: number) {
    this._suppliers?.forEach((supp) => {
      supp.flexValue = flexValue;
    });
    this.setSupplierMinMax();
  }

  unGroupAllSuppliers() {
    //Filter only suppliers that are groups
    const existingSupplierGroups = this._suppliers?.filter(
      (suppFilterGroup) =>
        suppFilterGroup.group_name !== '' && suppFilterGroup.group_name !== null
    );

    existingSupplierGroups?.forEach((groupToUngroup) => {
      const groupIndex = this._suppliers?.findIndex(
        (supp) => supp.group_name === groupToUngroup.group_name
      );
      if (groupIndex !== undefined && groupIndex >= 0) {
        const ungroupedSuppliers = this.deleteGroup(groupToUngroup);
        this._suppliers?.splice(groupIndex, 1, ...ungroupedSuppliers);
      }
    });
  }

  deleteGroup(groupSupp: SupplierResponseInterface) {
    let cpiObject: { [key: number]: string | number } = {};
    this.tempSuppliers.forEach((supplierObj) => {
      if (supplierObj.suppliers.length > 1) {
        supplierObj.suppliers.forEach((supplier) => {
          if (this._eligibleSuppliers) {
            const eligibleSupplier = this._eligibleSuppliers.filter(
              (eligibleSuppliers) => eligibleSuppliers.id === supplier.id
            );
            cpiObject[supplier.id] = eligibleSupplier[0].cpi;
          } else {
            cpiObject[supplier.id] = supplierObj.cpi;
          }
        });
      } else {
        cpiObject[supplierObj.suppliers[0].id] = supplierObj.cpi;
      }
    });
    groupSupp.suppliers.forEach((supp) => {
      supp.cpi = cpiObject[supp.id];
    });
    const supplierGoal = groupSupp.completes_goal / groupSupp.suppliers.length;
    let supplierGoalRemaining =
      groupSupp.completes_goal % groupSupp.suppliers.length;
    const supplierQuantity = Math.floor(
      groupSupp.quantity / groupSupp.suppliers.length
    );
    let supplierQuantityRemaining =
      groupSupp.quantity % groupSupp.suppliers.length;
    return groupSupp.suppliers.map((supp) => {
      const quantity =
        supplierQuantityRemaining > 0 ? supplierQuantity + 1 : supplierQuantity;
      const ungroupedSupp = this._setUngrouppedSupplierData(
        supp,
        supplierGoalRemaining,
        supplierGoal,
        quantity,
        groupSupp
      );
      supplierGoalRemaining--;
      supplierQuantityRemaining--;
      return ungroupedSupp;
    }) as SupplierResponseInterface[];
  }

  private _setUngrouppedSupplierData(
    supplier: EachSupplier,
    supplierGoalRemaining: number,
    supplierGoal: number,
    quantity: number,
    groupSupplier: SupplierResponseInterface
  ) {
    let actual_epc, platform_epc, estimate_epc, variable_margin, scpi;
    if (this.loggedInAsServiceBuyer) {
      [actual_epc, platform_epc, estimate_epc, variable_margin, scpi] =
        this._getSingleSupplierMetaData(supplier.id);
    }
    return {
      group_name: '',
      completes_goal:
        supplierGoalRemaining > 0 ? supplierGoal + 1 : supplierGoal,
      current_target:
        supplierGoalRemaining > 0 ? supplierGoal + 1 : supplierGoal,
      fielded: 0,
      cpi: supplier.cpi,
      block_price: supplier.cpi,
      bid_cpi: null,
      suppliers: [supplier],
      quantity,
      flexValue: 0,
      is_active: true,
      max: this.completesNeeded,
      isValid: true,
      isChecked: true,
      percentile: quantity
        ? Math.floor((quantity * 100) / this.completesNeeded)
        : 0,
      id: supplier.id,
      min: groupSupplier.min,
      feasibility: 0,
      actual_epc,
      platform_epc,
      estimate_epc,
      variable_margin,
      currency_symbol: groupSupplier.currency_symbol,
      scpi,
    };
  }

  private _getSingleSupplierMetaData(supplierId: number) {
    const singleSuppĺier = this.tempSuppliers.find((supplier) =>
      supplier.suppliers.some((s) => s.id === supplierId)
    )!;
    const {
      actual_epc,
      platform_epc,
      estimate_epc,
      variable_margin,
      currency_symbol,
      scpi,
    } = singleSuppĺier;
    return [
      actual_epc,
      platform_epc,
      estimate_epc,
      variable_margin,
      currency_symbol,
      scpi,
    ];
  }

  _setSupplierMinMaxWhenFlexibilityIsZero() {
    this.supplierFlex.value = 0;
    this._suppliers?.forEach((sup) => {
      this.totalAllocations += sup.quantity;
      sup['isFlexibility'] = false;
      sup['min'] = sup.quantity;
      sup['max'] = sup.quantity;
      sup['percentile'] =
        sup.quantity > 0
          ? Math.floor((sup.quantity * 100) / this.completesNeeded)
          : 0;
      sup.completes_goal = sup.max;
    });
  }

  _setSupplierMinMaxWhenFlexibilityIsHundredPercent() {
    this._suppliers?.forEach((sup) => {
      this.totalAllocations += sup.quantity;
      sup['percentile'] =
        sup.quantity > 0
          ? Math.floor((sup.quantity * 100) / this.completesNeeded)
          : 0;
      if (sup.quantity > 0 && sup.quantity != this.completesNeeded) {
        sup['min'] = 0;
        sup['max'] = this.completesNeeded;
      } else if (sup.quantity == this.completesNeeded) {
        sup['min'] = this.completesNeeded;
        sup['max'] = this.completesNeeded;
      } else {
        sup['min'] = 0;
        sup['max'] = 0;
      }
      sup.completes_goal = sup.max;
    });
  }

  _setMinVlaueForSuppliers(totalMin: number) {
    this._suppliers?.forEach((sup) => {
      let allocation = sup.quantity;
      allocation = Number(allocation) ? allocation : 0;
      sup['percentile'] =
        sup.quantity > 0
          ? Math.floor((sup.quantity * 100) / this.completesNeeded)
          : 0;
      this.totalAllocations += sup.quantity;
      // If total completes are allocated to single suplier the min ansd max are equal
      if (sup.quantity == this.completesNeeded) {
        sup['min'] = sup.quantity;
      } else {
        let min = allocation - allocation * (this.supplierFlex.value / 100);
        min = Math.ceil(min > 0 ? min : 0);
        totalMin += min;
        sup['min'] = min;
      }
    });
    return totalMin;
  }

  _setMaxValueForSuppliers(totalMin: number) {
    this._suppliers?.forEach((sup) => {
      let allocation = sup.quantity;
      sup['percentile'] =
        sup.quantity > 0
          ? Math.floor((sup.quantity * 100) / this.completesNeeded)
          : 0;
      allocation = Number(allocation) ? allocation : 0;
      // If total completes are allocated to single supplier the min ansd max are equal
      if (sup.quantity == this.completesNeeded) {
        sup['max'] = sup.quantity;
      } else {
        let max1 = allocation + (allocation * this.supplierFlex.value) / 100;
        if (totalMin > this.completesNeeded) {
          sup['max'] = sup.quantity;
        } else {
          sup['max'] = Math.floor(Math.min(max1, this.completesNeeded));
        }
      }
      sup.completes_goal = sup.max;
    });
  }

  _setSupplierMinMaxForGivenFlexibility() {
    let totalMin = 0;
    totalMin = this._setMinVlaueForSuppliers(totalMin);
    this._setMaxValueForSuppliers(totalMin);
  }

  redistributeSuppliers() {
    this._suppliers?.forEach((supp) => (supp.isChecked = false));
    this.removeBlends();
    this._suppliers?.forEach((supplier, index) => {
      if (supplier.cpi == 0 && !supplier.group_ref) {
        supplier.isValid = false;
        supplier.isChecked = false;
      } else {
        supplier.isValid = true;
        supplier.isChecked = true;
      }
    });
    this._doSupplierAllocation();
  }

  private _doSupplierAllocation() {
    this.selectAndDivideAllocation();
    this.setSupplierMinMax();
    if (this._suppliers && this._feasibilityData && this._buyerData) {
      this.cpi = this._cpiService.mapCpi(
        this._suppliers,
        this._buyerData,
        this._feasibilityData,
        true
      );
    }
  }

  selectAndDivideAllocation() {
    this.totalRemaining = 0;
    this.totalAllocations = 0;
    this.suppliersCount = 0;
    this.totalFeasibility = 0;

    this._suppliers?.forEach((supplier) => {
      if (supplier.isValid && supplier.isChecked) {
        this.suppliersCount++;
        supplier.suppliers.forEach((sup) => {
          sup.allocation = 100;
        });
      }
    });
    // Dividing Allocations
    this._suppliers?.forEach((supplier) => {
      if (supplier.isValid && supplier.isChecked) {
        supplier.quantity = Math.floor(
          this.completesNeeded / this.suppliersCount
        );
        supplier.current_target = supplier.quantity;
        this.totalFeasibility += supplier.feasibility || 0;
      } else {
        supplier.quantity = 0;
        supplier.current_target = supplier.quantity;
      }
      this.totalAllocations += supplier.quantity;
    });
    // For distributing the remaining allocation to suppliers
    let remaningCompletes = this.completesNeeded - this.totalAllocations;
    const allocationQuantity = 1;
    if (this.suppliersCount > this.completesNeeded) {
      this._suppliers?.forEach((supplier) => {
        if (supplier.isValid && supplier.isChecked) {
          supplier.quantity = supplier.quantity + allocationQuantity;
          supplier.current_target = supplier.quantity;
          this.totalAllocations = this.totalAllocations + allocationQuantity;
          remaningCompletes = remaningCompletes - allocationQuantity;
        }
      });
    } else if (this.suppliersCount && remaningCompletes > 0) {
      while (remaningCompletes > 0) {
        this._suppliers?.forEach((supplier) => {
          if (remaningCompletes > 0 && supplier.isValid && supplier.isChecked) {
            supplier.quantity = supplier.quantity + allocationQuantity;
            supplier.current_target = supplier.quantity;
            this.totalAllocations = this.totalAllocations + allocationQuantity;
            remaningCompletes = remaningCompletes - allocationQuantity;
          }
        });
      }
    }
    this.totalRemaining = this.completesNeeded - this.totalAllocations;
  }

  setSupplierMinMax() {
    this.totalAllocations = 0;
    if (!this.supplierFlex.isFlexible) {
      this._setSupplierMinMaxWhenFlexibilityIsZero();
    } else if (this.supplierFlex.value >= 100) {
      this._setSupplierMinMaxWhenFlexibilityIsHundredPercent();
    } else {
      this._setSupplierMinMaxForGivenFlexibility();
    }
    this.totalRemaining = this.completesNeeded - this.totalAllocations;
    const threshold = this._calculateSurveyPauseThreshold();
    if (this._flexibilityPrice.survey_pause_threshold < threshold) {
      this._flexibilityPrice.survey_pause_threshold = threshold;
    }
  }

  private _calculateSurveyPauseThreshold() {
    const supplierCpi = this._suppliers?.reduce(
      (partialSum, supplier) => partialSum + supplier.cpi * supplier.max,
      0
    );
    const supplierMax = this._suppliers?.reduce(
      (partialSum, supplier) => partialSum + supplier.max,
      0
    );
    return Number(((supplierCpi || 0) / (supplierMax || 1)).toFixed(2));
  }

  private _mapOverrideCpi(flexibility?: FlexibilityPricesParams) {
    this.globalPriceOveride = !!flexibility?.survey_price_override;
    this.selectivePriceOveride = flexibility?.manual_override || false;
    this.operatorOverrideCpi = !!flexibility?.survey_price_override
      ? String(new TruncateNumber(flexibility?.survey_price_override).places(2))
      : '';
  }

  public setGlobalOverrideCpi() {
    this._truncateOperatorOverride(this.operatorOverrideCpi);
    this.defaultPurePriceOverride = new PurePriceOverride(false, 0);
    this._surveyMetaDataService.setPurePriceOverride(
      this.defaultPurePriceOverride
    );
    this.updateCPI = true;
    if (!isNaN(parseFloat(this.operatorOverrideCpi))) {
      this.cpi?.forEach((c) => {
        c.cpi = Number(parseFloat(this.operatorOverrideCpi).toFixed(2));
      });
      this._suppliers?.forEach((c) => {
        c.cpi = Number(parseFloat(this.operatorOverrideCpi).toFixed(2));
      });
    } else {
      this._suppliers?.forEach((supplier, index) => {
        if (supplier.group_ref) {
          const cpi = this._feasibilityDataService.calculateGroupedSupplierCpi(
            supplier,
            this._eligibleSuppliers
          );
          supplier.cpi = cpi;
          this.cpi[index].cpi = cpi;
        } else {
          supplier.cpi = supplier.override_block_price || supplier.block_price;
          this.cpi[index].cpi =
            supplier.override_block_price || supplier.block_price;
        }
      });
    }

    if (!this.operatorOverrideCpi) {
      this.globalOverrideCpi = 0;
      return;
    }

    this.globalOverrideCpi = parseInt(this.operatorOverrideCpi);
    this.validateManualOverrideRules();
  }

  public setEntryLinkFlag(flag: boolean, id: string) {
    if (id == Constants.GLOBAL_OVERRIDE) {
      this.globalPriceOveride = flag;
      if (this.globalPriceOveride) {
        this.selectivePriceOveride = false;
        this.cpiOverrideConfirmation = Confirmation.rejected();
      } else {
        this.operatorOverrideCpi = '';
        this.setGlobalOverrideCpi();
        this.mcQbGlobalPriceOveride = false;
        this._resetCpiOverrideConfirmation();
      }
    } else if (id == Constants.SELECTIVE_OVERRIDE) {
      if (this.isAidaEnabled) {
        // do not allow selective override when AIDA is enabled
        return;
      }

      this.selectivePriceOveride = flag;
      if (this.selectivePriceOveride) {
        this.globalPriceOveride = false;
        this.mcQbGlobalPriceOveride = false;
        this.operatorOverrideCpi = '';
        this.updateCPI = true;
        this.cpiOverrideConfirmation = Confirmation.rejected();
        this.validateManualOverrideRules();
        this.defaultPurePriceOverride = new PurePriceOverride(false, 0);
        this._surveyMetaDataService.setPurePriceOverride(
          this.defaultPurePriceOverride
        );
      } else {
        if (this._flexibilityPrice.manual_override || this.updateCPI) {
          this.updateCPI = true;
        }
        this._suppliers?.forEach((supplier, index) => {
          if (supplier.group_ref) {
            const cpi =
              this._feasibilityDataService.calculateGroupedSupplierCpi(
                supplier,
                this._eligibleSuppliers
              );
            supplier.cpi = cpi;
            this.cpi[index].cpi = cpi;
          } else {
            supplier.cpi =
              supplier.override_block_price || supplier.block_price;
            this.cpi[index].cpi =
              supplier.override_block_price || supplier.block_price;
          }
        });
        this._resetCpiOverrideConfirmation();
      }
    } else if (id == Constants.MCQBGLABAL) {
      this.mcQbGlobalPriceOveride = flag;
      this.updateCPI = true;
    }
  }

  public _resetCpiOverrideConfirmation() {
    this.cpiOverrideConfirmation = Confirmation.confirmed();
    this.cpiRequireConfirmation = false;
  }

  public setSupplierOverrideFlag(flag: boolean) {
    this.updateCPI = true;
    this.manualSCPIOverrideEnabled = flag;
    if (!this.manualSCPIOverrideEnabled) {
      const margin = this._surveyDetails?.margin_override!.margin;
      if (margin) {
        this._suppliers?.forEach((supplier, index) => {
          const usdCpi = this._commonService.localToUSD(
            supplier.cpi,
            this._currencyExchangeRate.rate,
            this._currencyExchangeRate.CRRate
          );
          const scpi =
            this.companyFx !== CURRENCY_CODE.US ? usdCpi : supplier.cpi;
          const newSupplierCpi = scpi - (scpi * margin) / 100;
          supplier.scpi = Number(newSupplierCpi.toFixed(2));
          this.cpi[index].scpi = supplier.scpi;
        });
      }

      this._resetCpiOverrideConfirmation();
    } else {
      this.cpiOverrideConfirmation = Confirmation.rejected();
      this.validateManualOverrideRules();
    }

    this._surveyMetaDataService.setSupplierOverrideValue(
      this.manualSCPIOverrideEnabled
    );
  }

  selectInput(e: Event) {
    e.stopPropagation();
    (e.target as HTMLInputElement).select();
  }

  validateManualOverrideRules(cpiIndex?: number) {
    if (cpiIndex !== undefined) {
      const value = this.loggedInAsServiceBuyer
        ? this.cpi[cpiIndex].scpi
        : this.cpi[cpiIndex].cpi;
      this.cpiRequireConfirmation =
        value != undefined ? value > this.maxCpiThreshold : false;
    } else {
      this.cpiRequireConfirmation =
        this.cpi
          .map((c) =>
            this.loggedInAsServiceBuyer && !this.enableGlobalPriceOverRide
              ? c.scpi || 0
              : c.cpi
          )
          .some((cpi) => cpi > this.maxCpiThreshold) || false;
    }
    this.cpiOverrideConfirmation = this.cpiRequireConfirmation
      ? Confirmation.rejected()
      : Confirmation.confirmed();
  }

  numberOnly(event: any, allowDecimal: boolean = false): boolean {
    this.updateCPI = true;
    const charCode = event.which ? event.which : event.keyCode;
    let restrictedPattern: boolean =
      charCode > 31 && (charCode < 48 || charCode > 57);
    if (allowDecimal) {
      restrictedPattern = restrictedPattern && charCode != 46;
    }
    return !restrictedPattern;
  }

  formatCpi(changedCPI: number, i: number, serviceBuyer?: boolean) {
    if (changedCPI && !serviceBuyer) {
      this.cpi[i].cpi = Number(
        this._decimalPipe.transform(changedCPI, '2.0-2')?.replace(',', '')
      );
      this._suppliers?.map((supplier) => {
        const t = supplier.suppliers.find(
          (supp: { id: number }) => supp.id == this.cpi[i].id
        );
        if (t) {
          supplier.cpi = this.cpi[i].cpi;
        }
      });
    }
    if (changedCPI && serviceBuyer) {
      this.cpi[i].scpi = Number(
        this._decimalPipe.transform(changedCPI, '2.0-2')?.replace(',', '')
      );
      this._suppliers?.map((supplier) => {
        const t = supplier.suppliers.find(
          (supp: { id: number }) => supp.id == this.cpi[i].id
        );
        if (t) {
          supplier.scpi = this.cpi[i].scpi;
        }
      });
    }
  }
  avoidClose(e: Event) {
    e.stopPropagation();
  }

  onCpiOverrideConfirmation(confirmation: Confirmation): void {
    this.cpiOverrideConfirmation = confirmation;
    this.cpiRequireConfirmation = false;
  }

  private async _setSuppliers() {
    this._loading.loading = true;
    const completesOrClicksToAllocate =
      this._metadata.completesRequired ??
      (this._surveyDetails?.click_balancing
        ? this._surveyDetails?.estimated_clicks
        : this._surveyDetails?.completes_required);
    this._surveyMetaDataService.setShowPurepriceFlyout(
      this._flexibilityPrice.manual_override || false,
      this.manualSCPIOverrideEnabled
    );
    const isAugmentSurvey =
      CreateSurveyConstants.SURVEY_CATEGORY_CODE.AUGMENT ===
      this._surveyDetails?.survey_category_code;
    const suppliers = await this._cpiService.setSuppliers(
      this.cpi,
      this._flexibilityPrice.survey_price_override,
      this._flexibilityPrice.manual_override || false,
      this._flexibilityPrice.survey_pause_threshold,
      completesOrClicksToAllocate,
      this.loggedInAsServiceBuyer,
      this.manualSCPIOverrideEnabled,
      this._supplierBlendData,
      this.selectedBlend?.id,
      this._isPurePriceRateCardEnabled,
      this._suppliers,
      isAugmentSurvey,
      this.defaultPurePriceOverride.isActive()
    );
    const blendId = this.selectedBlend?.id || '';
    this._surveyMetaDataService.sendSuppliersSelected({
      suppliers: suppliers,
      blend_id: blendId,
    });

    if (this._surveyDetails) {
      this._surveyDetails.blend_id = this.selectedBlend?.id;
    }
    await delay(2000);
    this._loading.loading = false;
  }

  removeBlends() {
    this.selectedBlend = '';
    if (this._surveyDetails) {
      this._surveyDetails.blend_id = '';
    }
    this._sendSelectedBlendForUpdateInMcSvpCache(null);
  }

  itemChanged(e: Event, item: CPI) {
    item.selected = (e.target as HTMLInputElement).checked;
    if (this.cpi.some((c) => c.selected)) {
      this.updateCPI = true;
      this._surveyMetaDataService.updateManuallyEditedAllocationSaved(false);
    }
    this.removeBlends();
    if (this.cpi.some((c) => c.selected == false)) {
      this.isSuppliersListChecked = false;
    } else {
      this.isSuppliersListChecked = true;
    }
  }

  selectAll(e: Event) {
    const isSelected = (e.target as HTMLInputElement).checked;
    this.setAllSuppliersSelectedAs(isSelected);
  }

  setAllSuppliersSelectedAs(isSelected: boolean) {
    this.cpi.forEach((c) => {
      c.selected = isSelected;
    });

    if (isSelected) {
      this.updateCPI = true;
      this._surveyMetaDataService.updateManuallyEditedAllocationSaved(false);
    }
  }

  async openModal() {
    const isCpiDropdownClosed = true;
    // avoid multiple update supplier call checking if CPIs are up to date
    // this is needed because this function is also called on dropdown close
    const updateSuppliers = this._suppliers?.some(
      (s) =>
        // get same supplier in the cpi array and compare the cpi value
        s.cpi !== this.cpi.find((c) => c.id === s.id)?.cpi
    );
    if (!this._manualAllocationEdit) {
      this.updateSuppliersCPI(isCpiDropdownClosed, updateSuppliers);
    }
    const { surveyId } = this;
    const ref = this._modal.open(EditSuppliersModalComponent, {
      data: {
        surveyId,
        eligibleSuppliers: this._eligibleSuppliers,
        metadata: this._metadata,
        suppliers: this._suppliers,
        operatorOverrideCPI: this.operatorOverrideCpi,
        selectivePriceOveride: this.selectivePriceOveride,
        flexibilityPrice: this._flexibilityPrice,
        feasibilityData: this._feasibilityData,
        supplierBlendData: this._supplierBlendData,
        surveyDetails: this._surveyDetails,
        isServiceBuyerOperation: this._isServiceBuyerOperation,
        isPurePriceApplied: this.isPurePriceApplied,
        ismcQbGlobalPriceOveride: this.mcQbGlobalPriceOveride,
        currencyExchangeRate: this._currencyExchangeRate,
      },
      maxWidth: '100%',
      width: '95%',
    });
    return ref.onClose$.pipe(map((msg) => msg === 'ok'));
  }

  private async _updateSuppliers(updateSuppliers: boolean = true) {
    this._flexibilityPrice.manual_override = this.selectivePriceOveride;
    this._flexibilityPrice.survey_price_override =
      this.operatorOverrideCpi !== ''
        ? Number(this.operatorOverrideCpi)
        : undefined;
    if (updateSuppliers) {
      await this._setSuppliers();
    }
  }

  public async updateSuppliersCPI(
    closed: boolean,
    updateSuppliers: boolean = true
  ) {
    if (closed) {
      this.propagateCpiDropdownVisibilityState(false);
      // in the case of opening modal and only suppliers need to be updated
      if (!this.updateCPI && updateSuppliers && !this._manualAllocationEdit) {
        await this._updateSuppliers(updateSuppliers);
      }
      await this._updateMcqbSurvey();
      if (this.globalPriceOveride && this.isMCQBSurvey) {
        this._sendOverrideForUpdateInMcSvpCache();
      } else if (!this.globalPriceOveride && this.isMCQBSurvey) {
        this._sendMcSpvEachUpdateForCache({
          offer_price: Number(this.operatorOverrideCpi),
        });
      }
      // continue the normal flow
      if (this.updateCPI) {
        this.updateCPI = !updateSuppliers;
        await this._updateSuppliers(updateSuppliers);
      } else if (this._flexibilityPrice.manual_override) {
        this.globalPriceOveride = false;
        this.selectivePriceOveride = true;
      } else if (!this._flexibilityPrice.manual_override) {
        this.selectivePriceOveride = false;
        if (this._flexibilityPrice.survey_price_override == 0) {
          this.globalPriceOveride = true;
          this.operatorOverrideCpi = String(
            this._flexibilityPrice.survey_price_override
          );
        } else if (this.operatorOverrideCpi) {
          this.globalPriceOveride = true;
        } else {
          this.globalPriceOveride = false;
        }
      }
    } else if (!closed && this.cpiRequireConfirmation) {
      this._toastr.error(notifyMessage.CPI_CONFIRMATION_ERROR);
    }
  }

  propagateCpiDropdownVisibilityState(state: boolean) {
    this._cpiService.updateCpiVisibility(state);
  }

  public _truncateOperatorOverride(operatorOverrideCpi: string) {
    if (operatorOverrideCpi) {
      this.operatorOverrideCpi = String(
        new TruncateNumber(operatorOverrideCpi).places(2)
      );
    }
  }

  private _sendOverrideForUpdateInMcSvpCache() {
    if (!this.operatorOverrideCpi) {
      return;
    }
    if (this.mcQbGlobalPriceOveride) {
      this._sendMcSpvAllUpdateForCache();
      return;
    }

    this._sendMcSpvEachUpdateForCache({
      offer_price: Number(this.operatorOverrideCpi),
    });
  }

  private _sendMcSpvEachUpdateForCache(
    update: Partial<Omit<BuyerSurveyResponse, 'survey_localization'>>
  ) {
    const cache = {
      for: 'each' as const,
      data: [
        {
          survey_localization: this._surveyDetails?.survey_localization,
          ...update,
        },
      ],
    };
    this._multiCountryDraftService.sendMcSpvUpdateInCacheCommand(cache);
  }

  private _sendMcSpvAllUpdateForCache() {
    if (this.mcQbGlobalPriceOveride && this.operatorOverrideCpi) {
      const cache = {
        for: 'all' as const,
        data: {
          offer_price: Number(this.operatorOverrideCpi),
        },
      };

      this._multiCountryDraftService.sendMcSpvUpdateInCacheCommand(cache);
    }
  }

  private _setSelectedMcSpvSurveyFeasibilityCpi() {
    const cache = {
      for: 'each' as const,
      data: [
        {
          feasibility_cpi: Number(this.totalCPI),
          offer_price: 0,
          survey_localization: this._surveyDetails?.survey_localization,
        },
      ],
    };
    this._multiCountryDraftService.sendMcSpvUpdateInCacheCommand(cache);
  }

  private async _updateMcqbSurvey() {
    if (!this.isMCQBSurvey) {
      return;
    }

    if (this.operatorOverrideCpi) {
      if (this.mcQbGlobalPriceOveride) {
        this._mcSuvSurveyPayload?.surveys?.map(
          (survey) => (survey.offer_price = Number(this.operatorOverrideCpi))
        );
      } else {
        this._mcSuvSurveyPayload?.surveys
          ?.filter(
            (survey) =>
              survey.survey_localization ===
              this._surveyDetails?.survey_localization
          )
          .map(
            (survey) => (survey.offer_price = Number(this.operatorOverrideCpi))
          );
        this._mcSuvSurveyPayload.offer_price = undefined;
      }
    } else {
      this._mcSuvSurveyPayload?.surveys
        ?.filter(
          (survey) =>
            survey.survey_localization ===
            this._surveyDetails?.survey_localization
        )
        .map((survey) => delete survey.offer_price);
    }

    await this._multiCountryService
      .updateSurvey(
        this._mcSuvSurveyPayload,
        this._surveyDetails?.ps_project_id!
      )
      .toPromise();
  }

  public onExpandRow(row: number): void {
    this.expandable?.expand(row);
  }

  public getCompletionPercantageRate(survey: SimilarProjectsResponse) {
    return ((survey.fielded * 100) / survey.completes_required).toFixed(2);
  }

  public getQualifications(
    survey: SimilarSurvey,
    numberQualification: number = -1
  ): string {
    const totalQualifications = survey.qualifications.length;
    return survey.qualifications
      .slice(
        0,
        numberQualification === -1 ? totalQualifications : numberQualification
      )
      .map((q) => q.qualification_name)
      .join(', ');
  }

  public redirectToSurvey(surveyId: number) {
    if (surveyId) {
      const newUrl = this._route.serializeUrl(
        this._route.createUrlTree([`/dashboard/${surveyId}`])
      );
      window.open(newUrl, '_blank');
    }
  }

  public isCheckedCompanyId(cmp: number) {
    if (this._auth.isLoggedInAsServiceBuyer()) {
      return !!(this._auth.serviceBuyer?.id === cmp);
    }
    return !!(this._auth.user && this._auth.user?.cmp === cmp);
  }

  public showSimilarProjectPogressBar: boolean = false;
  public isSimilarProjectsLoaded: boolean = false;
  public progressBarLabel: string;
  public similarProjectPayload: SimilarProjectsRequest;
  private _similarProjectCommand$ = new EventEmitter<boolean>();
  public showResyncButton: boolean = false;

  showQualificationsArea() {
    setTimeout(() => {
      this.similarSurveys.forEach((_, index: number) => {
        this.onExpandRow(index);
      });
    }, 0);
  }

  interruptTheSearch() {
    this._cancelCommand$.next();
    this._resetSimilarProjectValues();
    this.similarSurveys = [];
    this.showResyncButton = true;
    this.isSearchCancelled = true;
  }

  private _getSimilarProjects() {
    if (!this.isSimilarProject) {
      return;
    }

    const similarProjectPayload$ = this._similarProjectsService
      .getSimilarProjectPayload()
      .pipe(
        debounceTime(100),
        distinctUntilChanged(isEqual),
        tap((payload) => {
          if (
            payload &&
            this.similarProjectPayload &&
            payload.survey_localization !==
              this.similarProjectPayload.survey_localization
          ) {
            this.showSimilarProjectPogressBar = false;
            this.isSimilarProjectsLoaded = false;
          }
          this.similarProjectPayload = payload;
          this.showResyncButton = true;
        })
      );

    const similarProjectsCommand$ = this._similarProjectCommand$.pipe(
      filter((shouldLoadData) => shouldLoadData),
      tap(() => (this.isSearchCancelled = false)),
      switchMap(() =>
        this._similarProjectsService
          .getSurveys(this.similarProjectPayload, this.isGlobalSearch)
          .pipe(takeUntil(this._cancelCommand$))
      ),
      catchError(({ error }) => {
        this._toastr.error(error?.ps_api_response_message);
        return of([]);
      }),
      tap(() => {
        this._toastr.success(
          notifyMessage.successMessage.SIMILAE_SURVEYS_SEARCH_COMPLETE
        );
      }),
      filter((projects) => {
        if (!projects.length) {
          this._resetSimilarProjectValues();
          this.similarSurveys = [];
        }
        return !!projects.length;
      })
    );

    this._subscriptions.add(similarProjectPayload$.subscribe());

    this._subscriptions.add(
      similarProjectsCommand$.subscribe((res) => {
        this.similarSurveys = res;
        this._resetSimilarProjectValues();
        this.showQualificationsArea();
      })
    );
  }

  private _resetSimilarProjectValues() {
    this.showSimilarProjectPogressBar = false;
    this.isSimilarProjectsLoaded = true;
    this.showResyncButton = false;
  }

  loadSimilarSurveys(showProgressBar: boolean) {
    this.showSimilarProjectPogressBar = showProgressBar;
    this._similarProjectCommand$.next(this.showSimilarProjectPogressBar);
  }

  similarProjectsAccordionToggle(event: SectionToggleInfo) {
    if (
      event.index === 1 &&
      event.opened &&
      !this.showSimilarProjectPogressBar
    ) {
      this.loadSimilarSurveys(!this.isSimilarProjectsLoaded);
      return;
    }
  }

  public isClickSurvey() {
    return !!this._surveyDetails?.click_balancing;
  }

  public searchCompanyOutSide() {
    this.isGlobalSearch = true;
    this.showSimilarProjectPogressBar = true;
    this._similarProjectCommand$.next(this.showSimilarProjectPogressBar);
    this.isDoneGlobalSearch = true;
  }

  ngOnDestroy(): void {
    this._subscriptions.unsubscribe();
  }
}
